import mitt from 'mitt'
import type { OrderableErrorEvent } from '@/types/Orderable'

export const orderableEventBus = mitt<{ 'orderable-error': OrderableErrorEvent }>()

export const emitOrderableError = (err: XMLHttpRequest, toastMessage: string) => {
  const { status, data } = err.response
  orderableEventBus.emit('orderable-error', { status, data, toastMessage })
}